import { createMuiTheme } from '@material-ui/core/styles';

import { hexToRgb } from '../../../utils';

export default createMuiTheme({
  palette: {
    background: {
      default: 'rgba(255, 255, 255, 0)',
    },
    primary: {
      light: '#5d6ca4',
      main: '#313955',
      contrastText: '#fff',
      soft: '#dfe2ed',
      translucent: '#a8b0ce',
    },
    secondary: {
      light: 'rgba(204, 244, 234, 0.87)',
      main: '#00c896',
      contrastText: '#fff',
    },
    error: {
      light: '#ff9800',
      main: '#e15863',
      contrastText: '#fff',
    },
    action: {
      selected: 'rgba(255, 255, 255, 0.08)',
      hover: 'rgba(255, 255, 255, 0.04)',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    blueGrey: {
      25: '#f5f7f8',
      50: '#eceff1',
      100: '#cfd8dc',
      200: '#b0bec5',
      300: '#90a4ae',
      400: '#78909c',
      500: '#607d8b',
      600: '#546e7a',
      700: '#455a64',
      800: '#37474f',
      900: '#263238',
    },
    status: {
      success: '#8bc34a',
      info: '#2196f3',
      warning: '#ff9800',
      error: {
        main: '#e15863',
        background: '#f9dee0',
      },
      note: {
        main: '#f3ab32',
        background: 'rgba(251, 229, 193, 0.87)',
      },
    },
    hexToRgb,
  },
  typography: {
    useNextVariants: true,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1280,
        lg: 1334,
        xl: 1600,
      },
    },
    fontFamily: [
      '"Apple SD Gothic Neo"',
      '"Nanum Gothic"',
      '"나눔고딕"',
      'NanumGothic',
      '"돋움"',
      'Dotum',
      '"굴림"',
      'Gulim',
      'Helvetica',
      'sans-serif',
    ].join(','),
    h2: {
      color: '#212121',
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    caption: {
      color: '#212121',
      fontSize: 16,
    },
    button: {
      textTransform: 'initial',
    },
  },
  overrides: {
    MuiButton: {
      text: {
        minWidth: 90,
        padding: '6px 8px',
        color: '#9e9e9e',
        fontSize: '0.875rem',
        lineHeight: 1.5,
      },
      outlined: {
        minWidth: 90,
        padding: '7px 8px 6px 8px',
        color: '#616161',
        fontSize: '0.875rem',
        lineHeight: 1.5,
      },
      contained: {
        minWidth: 90,
        padding: '6px 8px',
        fontSize: '0.875rem',
        lineHeight: 1.5,
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTableCell: {
      head: {
        lineHeight: 'normal',
      },
      body: {
        lineHeight: 'normal',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.8125rem',
      },
    },
    MuiPaper: {
      elevation8: {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
      },
    },
    MuiSnackbar: {
      anchorOriginBottomCenter: {
        left: '50%',
        bottom: '5rem',
        minWidth: 212,
        transform: 'translateX(-50%)',
      },
    },
    MuiSnackbarContent: {
      root: {
        display: 'flex',
        justifyContent: 'center',
        minWidth: 280,
        padding: 0,
        color: '#e0e0e0',
        backgroundColor: '#212121',
        fontSize: 14,
        lineHeight: 1.53,
        boxShadow: 'none',
      },
      message: {
        padding: '14px 16px',
        lineHeight: 1.43,
        textAlign: 'center',
      },
    },
    MuiDialog: {
      paper: {
        minWidth: 'calc(100% - 48px)',
      },
    },
    MuiDialogContent: {
      root: {
        fontSize: 16,
        lineHeight: 1.5,
        color: 'rgba(0, 0, 0, 0.54)',
      },
    },
  },
});
